import React, { useState, useEffect } from "react";
import "./stylesTicketLengthBreakdown.css";
import dayjs from "dayjs";

import CustomDatePicker from "../../../CommonComponents/CustomDatePicker/CustomDatePicker";
import createPrivateAdminPanelInstance from "../../../../api/PrivateAdminPanelInstance";
import RebetLoader from "../../../CommonComponents/RebetLoader/RebetLoader";
import { API_ROUTES } from "../../../../api/ApiRoutes";
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend
} from 'chart.js';
import { Pie } from "react-chartjs-2";

ChartJS.register(
  ArcElement,
  Tooltip,
  Legend
);

const options = {
  plugins: {
    legend: {
      display: false,
    },
    datalabels: {
      display: false,
    },
    tooltip: {
      enabled: true,
      backgroundColor: "#252729",
      titleFont: {
        family: "Poppins-regular",
        size: 16,
        weight: "bold",
      },
      bodyFont: {
        family: "Poppins-regular",
        size: 14,
      },
      padding: 15,
      displayColors: true,
      callbacks: {
        label: function (tooltipItem) {
          const label = tooltipItem.dataset.label || "";
          const value = tooltipItem.raw;
          return `${label}: ${Intl.NumberFormat("en-US").format(value)}`;
        },
      },
    },
  },
};

const colors = [
  "#23B7E5",
  "#FFFFFF",
  "#F5B849",
  "#26BF94",
  "#6E2EF5",
  "#E6533C",
  "#FD6F0F",
  "#67000d"
];

function TicketLengthBreakdown() {
  const token = JSON.parse(localStorage.getItem("token"));
  const PrivateAdminPanelInstance = createPrivateAdminPanelInstance(
    token?.IdToken
  );

  const thisMonthRange = [dayjs().startOf("month"), dayjs().endOf("month")];
  const [chartData, setChartData] = useState({
    labels: [],
    datasets: [
      {
        label: false,
        data: [],
        backgroundColor: [],
        borderColor: [],
        borderWidth: 1,
      },
    ],
  });
  const labels = chartData?.labels;

  const [isLoading, setIsLoading] = useState(false);
  const [dates, setDates] = useState(thisMonthRange);

  const getTicketLengthBreakdownData = async (
    queryString = thisMonthRange,
    isQueryString = true
  ) => {
    setIsLoading(true);

    let startDate = "";
    let endDate = "";

    if (isQueryString) {
      let formattedQueryString = queryString.split("&");
      startDate = dayjs(formattedQueryString[0]).format("YYYY-MM-DD");
      endDate = dayjs(formattedQueryString[1]).format("YYYY-MM-DD");
    } else {
      startDate = queryString[0]?.format("YYYY-MM-DD");
      endDate = queryString[1]?.format("YYYY-MM-DD");
    }

    try {
      const response = await PrivateAdminPanelInstance?.post(
        API_ROUTES?.GET_TICKET_LENGTH_BREAKDOWN,
        {
          start_date: startDate,
          end_date: endDate,
        }
      );

      const data = response?.data?.data.data;
      const labels = data.map((item) => item.label);
      const values = data.map((item) => item.value);

      const chartData = {
        labels: labels,
        datasets: [
          {
            label: false,
            data: values,
            backgroundColor: colors,
            borderColor: colors,
            borderWidth: 1,
          },
        ],
      };
      setChartData(chartData);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getTicketLengthBreakdownData(dates, false);
  }, []);

  return (
    <div className="ticket-length-breakdown-container">
      <div className="ticket-length-breakdown-header">
        <h2>Ticket Length Breakdown</h2>
        <CustomDatePicker
          getData={getTicketLengthBreakdownData}
          dates={dates}
          setDates={setDates}
          showPresets={true}
        />
      </div>
      <div className="ticket-length-breakdown-content">
        {isLoading ? (
          <RebetLoader width={100} height={100} />
        ) : (
          <>
          <div className="ticket-length-breakdown-chart">
            <Pie data={chartData} options={options} />
          </div>
          <div className="ticket-length-breakdown-legend">
            {labels.map((label, index) => (
              <div className="ticket-length-breakdown-legend-item" key={index}>
                <div className="ticket-length-breakdown-legend-item-color" style={{ backgroundColor: colors[index] }} />
                <span className="ticket-length-breakdown-legend-item-label">{label}</span>
              </div>
            ))}
          </div>
          </>
        )}
      </div>
    </div>
  );
}

export default TicketLengthBreakdown;
